import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'mandates-invalid-mandates-import-dialog',
  templateUrl: './invalid-mandates-import-dialog.component.html',
  styleUrls: ['./invalid-mandates-import-dialog.component.scss'],
})
export class InvalidMandatesImportDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<InvalidMandatesImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormGroup[]
  ) {}

  ngOnInit(): void {}
}
